export interface ValidationErrors {
    lot_id?: string
    lot_ids?: string
    terminal_id?: string
    treasure_capacity?: string
    inactivity_timeout_ms?: string
    inactivity_countdown_s?: string
    inactivity_countdown_successful_page_s?: string
    overpaid_countdown_s?: string
    cashless_pu?: string
    cashless_tid?: string
    gate_id?: string
    min_confidence_level?: string
    night_brightness?: string
    day_brightness?: string
}

// Common validation functions
const isPositiveNumber = (value: any): boolean => typeof value === 'number' && value > 0
const isValidLotId = (value: string): boolean => /^[a-zA-Z0-9-]+$/.test(value)
const isValidLotIds = (value: string): boolean =>
    value
        .split(',')
        .map((v) => v.trim())
        .every((v) => /^[a-zA-Z0-9-]+$/.test(v))

export const validateBasicConfig = (state: any): ValidationErrors => {
    if (!state) return {}

    const errors: ValidationErrors = {}

    // Common Fields
    if (!isValidLotId(state.lot_id)) {
        errors.lot_id = 'Lot ID must consist of alphanumeric characters and dashes only'
    }

    if (
        state.lot_ids !== undefined &&
        state.lot_ids !== null &&
        state.lot_ids.trim() !== '' &&
        !isValidLotIds(state.lot_ids)
    ) {
        errors.lot_ids = 'Each Lot ID must consist of alphanumeric characters and dashes only, separated by commas'
    }

    // Terminal-specific fields
    if (state.terminal_id !== undefined && !isPositiveNumber(state.terminal_id)) {
        errors.terminal_id = 'Terminal ID must be a positive number'
    }
    if (state.treasure_capacity !== undefined && !isPositiveNumber(state.treasure_capacity)) {
        errors.treasure_capacity = 'Treasure Capacity must be a positive number'
    }
    if (state.inactivity_timeout_ms !== undefined && !isPositiveNumber(state.inactivity_timeout_ms)) {
        errors.inactivity_timeout_ms = 'Time till inactivity must be a positive number'
    }
    if (state.inactivity_countdown_s !== undefined && !isPositiveNumber(state.inactivity_countdown_s)) {
        errors.inactivity_countdown_s = 'Time till inactivity must be a positive number'
    }
    if (
        state.inactivity_countdown_successful_page_s !== undefined &&
        !isPositiveNumber(state.inactivity_countdown_successful_page_s)
    ) {
        errors.inactivity_countdown_successful_page_s = 'Time to view success page must be a positive number'
    }
    if (state.overpaid_countdown_s !== undefined && !isPositiveNumber(state.overpaid_countdown_s)) {
        errors.overpaid_countdown_s = 'Time to react to overpayment question must be a positive number'
    }
    if (
        state.cashless_pu !== undefined &&
        (!isPositiveNumber(state.cashless_pu) || !/^\d{4}$/.test(state.cashless_pu.toString().padStart(4, '0'))) &&
        (state.cashless_configure_job === 'cashless_config_job' ||
            state.cashless_configure_job === 'initialization_job') &&
        state.cashless_configure_enabled === true
    ) {
        errors.cashless_pu = 'Cashless PU must be a four-digit number'
    }

    if (
        state.cashless_tid !== undefined &&
        (state.cashless_tid <= 0 || !/^\d{8}$/.test(state.cashless_tid.toString().padStart(8, '0'))) &&
        (state.cashless_configure_job === 'cashless_config_job' ||
            state.cashless_configure_job === 'initialization_job') &&
        state.cashless_configure_enabled === true
    ) {
        errors.cashless_tid = 'Cashless TID must be an eight-digit number'
    }

    // Display-specific fields
    if (state.gate_id !== undefined && !isPositiveNumber(state.gate_id)) {
        errors.gate_id = 'Gate ID must be a positive number'
    }
    if (
        state.min_confidence_level !== undefined &&
        (state.min_confidence_level < 0 || state.min_confidence_level > 1)
    ) {
        errors.min_confidence_level = 'Confidence level must be between 0 and 100'
    }
    if (state.night_brightness !== undefined && (state.night_brightness < 0 || state.night_brightness > 1)) {
        errors.night_brightness = 'Night brightness must be between 0 and 100'
    }
    if (state.day_brightness !== undefined && (state.day_brightness < 0 || state.day_brightness > 1)) {
        errors.day_brightness = 'Day brightness must be between 0 and 100'
    }

    return errors
}
